export const kustomerInitEvent = 'kustomerLoaded'  
export const urlToken = 'https://ftd-kustomer-services-voqp7ipqwq-uc.a.run.app/kustomer/customer/token';
export const kustomerOptions = {
  hideChatIcon: true,
  chatIconSize: { height:90, width: 90 },
  brandId: '6568c26e7b58ae5d2181462f'
};
export enum ChatProvider {
  ZENDESK = 'ZENDESK',  
  KUSTOMER = 'KUSTOMER', 
  UNSELECTED = 'UNSELECTED'
}

interface IconSize {
  height: number;
  width: number;
};

export interface TokenParamInterface {
  jwtToken: string;
} 

export interface TokenParams {
  email: string;
  externalId: string;
};

export interface LoginResponseInterface {
  email: string;
  customerId: string;
  externalId: string;
  identified: boolean;
}

export interface ChatIconPositionInterface { 
  alignment: 'right' | 'left';
  verticalPadding: number;
  width: number;
}

export interface KustomerOptionsInterface {
  lang?: string;
  zIndex?: number;
  brandId?: string;
  scheduleId?: string;
  allowZoom?: boolean;
  assistantId?: string;
  hideHistory?: boolean;
  hideChatIcon?: boolean;
  chatIconSize?: IconSize;
  preferredView?: 'chat'| 'kb';
  showTitleNotifications?: boolean;
  hideArticleOpenInNewTab?: boolean;
  showBrowserNotifications?: boolean;
  chatIconPosition?: ChatIconPositionInterface;
  hideNewConversationButtonOnEnd?: boolean;
  hideNewConversationButtonOnHistory?: boolean;
} 

export interface ConversationOptionsInterface {
  message?: string;
  assistantId?: string;
  customAttributes?: any;
} 

export interface DescribeCustomerOptionsInterface {
  attributes?: {
    emails: string[];
    phones: string[];
    socials?: {username: string, type: string}[];
  };
  customAttributes?: any;
} 

export interface CallbackResponseInterface {
  identified: boolean;
  customerId: string;
  email?: string;
  externalId?: string;
} 

export interface ErrorInterface {
  source: string;
  status: string;
} 

export interface ZendeskTickesInterface {
  status?: string;
  createDate?: string;
  json?: string;
  orderId?:  number;
  statusId?: number;
  ticketId?: string;
  tmp?: string;
  userId?: number;
} 

export interface TokenInterface {
  jwtToken: string;
} 

export interface KustomerInterface {
  open?: (callback?: () => void) => void;
  close?: (callback?: () => void) => void;
  start?: (options?: KustomerOptionsInterface, callback?: () => void) => void;
  createConversation?: (options?: ConversationOptionsInterface, callback?: () => void) => void;
  describeCustomer?: (options?: DescribeCustomerOptionsInterface, callback?: () => void) => void;
  login?: (token?: TokenInterface, callback?: (callbackResponse: CallbackResponseInterface, error: ErrorInterface) => void) => void;
} 